import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';

import FormControlLabel from '@material-ui/core/FormControlLabel'
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import ListItem from '@material-ui/core/ListItem';
import Checkbox from '@material-ui/core/Checkbox';
import { API,Storage } from 'aws-amplify';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';


import CircularProgress from '@material-ui/core/CircularProgress';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import './App.css';

function Copyright(props) {
    return (
      <Typography variant="body2" color="textSecondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="https://www.acesecurity.com.au/">
          ACES Group
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }
  
  
const theme = createTheme();

const ReviewDocuments = (user) => {

  const BlackTextTypography = withStyles({
    root: {
      color: "#000000"
    }
  })(Typography);
  

    const [requestor, setReqestor] = React.useState(user?.user?.username);
    const [consentList, setConsentList] = React.useState([]);
    const [consent, setConsent] = React.useState(false);

    const [formSuccess, setFormSuccess] = React.useState('Thank you');
    const [success, setSuccess] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [initialising, setInitialising] = React.useState(false);

    const isCancelled = React.useRef(false);


    const [documents, setDocuments] = React.useState([{
    "name":"general",
    "displayName":"",
    "documents":[{"name":"ACES WHSQE v11","path":"ACES WHSQE MS_v11.pdf","consent":false},
      {"name":"Fair-Work-Information-Statement",
      "path":"FOR_071 Fair-Work-Information-Statement_External_Doc.pdf","consent":false}, 
      {"name":"Casual Employment Information Statement","path":"FOR_072 Casual_Employment_Information_Statement_External_Doc.pdf","consent":false},
      {"name":"Permanent Employment ACESGroup Enterprise Agreement","path":"ACESecurity_Permanent Employees EA 2007 inc Schedule B 2021_07_01 and Add Terms.pdf","consent":false},
      {"name":"Casual Employment ACESGroup Enterprise Agreement ","path":"ACESecurity_Casual Employees EA 2007 inc Schedule B_2021_11_01.pdf"}]
},
   {
    "name":"pols",
    "displayName":"ACES Policies",
    "documents":[{"name":"POL_001 - WHSQE Policy_v6","path":"POL_001 - WHSQE Policy_v6.pdf","consent":false},
    {"name":"POL_002 - Risk Management Policy_v6","path":"POL_002 - Risk Management Policy_v6.pdf","consent":false},
    {"name":"POL_003 - Code of Conduct Policy_v8","path":"POL_003 - Code of Conduct Policy_v8.pdf","consent":false},
    {"name":"POL_004 - Employee Performance Review Policy_v3","path":"POL_004 - Employee Performance Review Policy_v3.pdf","consent":false},
    {"name":"POL_005 - Employee Complaints and Greivance Handling_v5","path":"POL_005 - Employee Complaints and Greivance Handling_v5.pdf","consent":false},
    {"name":"POL_006 - Customer Service Policy_v7","path":"POL_006 - Customer Service Policy_v7.pdf","consent":false},
    {"name":"POL_009 - Employee Performance Management Policy_v7","path":"POL_009 - Employee Performance Management Policy_v7.pdf","consent":false},
    {"name":"POL_010 - Recruitment Policy_v13","path":"POL_010 - Recruitment Policy_v13.pdf","consent":false},
    {"name":"POL_012 - Access and Equity and Equal Opportunities Policy_v8","path":"POL_012 - Access and Equity and Equal Opportunities Policy_v8.pdf","consent":false},
    {"name":"POL_013 - Fitness for Work Drug and Alcohol Policy_v11","path":"POL_013 - Fitness for Work Drug and Alcohol Policy_v11.pdf","consent":false},
    {"name":"POL_014 - Leave Policy_v7","path":"POL_014 - Leave Policy_v7.pdf","consent":false},
    {"name":"POL_015 - Employee Training Policy_v8","path":"POL_015 - Employee Training Policy_v8.pdf","consent":false},
    {"name":"POL_016 - Harassment Policy_v9","path":"POL_016 - Harassment Policy_v9.pdf","consent":false},
    {"name":"POL_017 - Uniform Presentation and Grooming Policy_v10","path":"POL_017 - Uniform Presentation and Grooming Policy_v10.pdf","consent":false},
    {"name":"POL_020 - Meal Break Policy_v8","path":"POL_020 - Meal Break Policy_v8.pdf","consent":false},
    {"name":"POL_022 - Privacy Policy Employment and Training_v12","path":"POL_022 - Privacy Policy Employment and Training_v12.pdf","consent":false},
    {"name":"POL_025 - Sun Protection Policy_v5","path":"POL_025 - Sun Protection Policy_v5.pdf","consent":false},
    {"name":"POL_031 - Apprehension Arrest and Detention Policy_v6","path":"POL_031 - Apprehension Arrest and Detention Policy_v6.pdf","consent":false},
    {"name":"POL_038 - Acceptable Workplace Practices Policy_v9","path":"POL_038 - Acceptable Workplace Practices Policy_v9.pdf","consent":false},
    {"name":"POL_039 - Workplace Smoking Policy_v6","path":"POL_039 - Workplace Smoking Policy_v6.pdf","consent":false},
    {"name":"POL_040 - Social Media Policy_v6","path":"POL_040 - Social Media Policy_v6.pdf","consent":false},
    {"name":"POL_041 - Email and Internet Policy_v8","path":"POL_041 - Email and Internet Policy_v8.pdf","consent":false},
    {"name":"POL_042 - Workplace Surveillance Policy_v6","path":"POL_042 - Workplace Surveillance Policy_v6.pdf","consent":false},
    {"name":"POL_045 - Injury Mgt and Return to Work Policy_v7","path":"POL_045 - Injury Mgt and Return to Work Policy_v7.pdf","consent":false},
    {"name":"POL_048 - Fatigue Management Policy_v5","path":"POL_048 - Fatigue Management Policy_v5.pdf","consent":false},
    {"name":"POL_054 - Uniform and Presentation Policy Security Licence_v6","path":"POL_054 - Uniform and Presentation Policy Security Licence_v6.pdf","consent":false},
    {"name":"POL_062 - Infection Prevention and Control Policy_v3","path":"POL_062 - Infection Prevention and Control Policy_v3.pdf","consent":false},
    {"name":"POL_101 - Biometric Information Privacy Policy_v3","path":"POL_101 - Biometric Information Privacy Policy_v3.pdf","consent":false},
    {"name":"POL_104 - COVID19 Vaccination Policy v1","path":"POL_104 - COVID19 Vaccination Policy v1.pdf"}]
},
{
  "name":"sops",
  "displayName":"ACES Standard Operating Procedures",
  "documents":[{"name":"SOP_001 - Starting Duty Shift_v6","path":"SOP_001 - Starting Duty Shift_v6.pdf","consent":false},
{"name":"SOP_002 - Finishing Duty Shift_v6","path":"SOP_002 - Finishing Duty Shift_v6.pdf","consent":false},
{"name":"SOP_003 - Use of Radio_v6","path":"SOP_003 - Use of Radio_v6.pdf","consent":false},
{"name":"SOP_004 - Issuing & Recieving Assets - Keys, Radios_v6","path":"SOP_004 - Issuing & Recieving Assets - Keys, Radios_v6.pdf","consent":false},
{"name":"SOP_005 - Operational Management of Activities_v6","path":"SOP_005 - Operational Management of Activities_v6.pdf","consent":false},
{"name":"SOP_006 - Working with External Agencies & Related Stakeholders_v6","path":"SOP_006 - Working with External Agencies & Related Stakeholders_v6.pdf","consent":false},
{"name":"SOP_007 - Preparing and Submitting Reports_v6","path":"SOP_007 - Preparing and Submitting Reports_v6.pdf","consent":false},
{"name":"SOP_008 - Receive and Respond to Complaints_v6","path":"SOP_008 - Receive and Respond to Complaints_v6.pdf","consent":false},
{"name":"SOP_009 - Patrol General (On Foot)_v7","path":"SOP_009 - Patrol General (On Foot)_v7.pdf","consent":false},
{"name":"SOP_010 - Secure Premises 'Lockdown'_v6","path":"SOP_010 - Secure Premises 'Lockdown'_v6.pdf","consent":false},
{"name":"SOP_011 - Responding to an Incident or Occurrence_v6","path":"SOP_011 - Responding to an Incident or Occurrence_v6.pdf","consent":false},
{"name":"SOP_012 - Incident or Occurrence Field Reporting_v7","path":"SOP_012 - Incident or Occurrence Field Reporting_v7.pdf","consent":false},
{"name":"SOP_013 - Responding to an Emergency_v6","path":"SOP_013 - Responding to an Emergency_v6.pdf","consent":false},
{"name":"SOP_014 - Responding to an Offence_v6","path":"SOP_014 - Responding to an Offence_v6.pdf","consent":false},
{"name":"SOP_015 - Regulating Authorised and Preventing Unauthorised Activities_v6","path":"SOP_015 - Regulating Authorised and Preventing Unauthorised Activities_v6.pdf","consent":false},
{"name":"SOP_016 - First Aid Responses_v6","path":"SOP_016 - First Aid Responses_v6.pdf","consent":false},
{"name":"SOP_017 - Barricade Procedures_v6","path":"SOP_017 - Barricade Procedures_v6.pdf","consent":false},
{"name":"SOP_018 - Patron Access & Entry Management & Search Procedures_v6","path":"SOP_018 - Patron Access & Entry Management & Search Procedures_v6.pdf","consent":false},
{"name":"SOP_019 - Worker Injury Management Process_v9","path":"SOP_019 - Worker Injury Management Process_v9.pdf","consent":false},
{"name":"SOP_020 - Separated & Lost Persons_v6","path":"SOP_020 - Separated & Lost Persons_v6.pdf","consent":false},
{"name":"SOP_021 - Vehicle Operating Procedures_v6","path":"SOP_021 - Vehicle Operating Procedures_v6.pdf","consent":false},
{"name":"SOP_022 - Escorting Person(s) Off Premises_v6","path":"SOP_022 - Escorting Person(s) Off Premises_v6.pdf","consent":false},
{"name":"SOP_023 - Cash Handling_v6","path":"SOP_023 - Cash Handling_v6.pdf","consent":false},
{"name":"SOP_024 - Retail Loss Prevention_v6","path":"SOP_024 - Retail Loss Prevention_v6.docx","consent":false},
{"name":"SOP_025 - RSA Monitoring_v7","path":"SOP_025 - RSA Monitoring_v7.pdf","consent":false},
{"name":"SOP_026 - Hand Held Metal Detector_v6","path":"SOP_026 - Hand Held Metal Detector_v6.pdf","consent":false},
{"name":"SOP_027 - Walk Through Metal Detector_v6","path":"SOP_027 - Walk Through Metal Detector_v6.pdf","consent":false},
{"name":"SOP_029 - Wristbanding Removal_v6","path":"SOP_029 - Wristbanding Removal_v6.pdf","consent":false},
{"name":"SOP_030 - Show Stop Procedure_v6","path":"SOP_030 - Show Stop Procedure_v6.pdf","consent":false},
{"name":"SOP_032 - Safe Cycling Patrol_v4","path":"SOP_032 - Safe Cycling Patrol_v4.pdf","consent":false},
{"name":"SOP_033 - Gator Operating Procedures_v4","path":"SOP_033 - Gator Operating Procedures_v4.pdf","consent":false},
{"name":"SOP_034 - Lost and Found Property_v6","path":"SOP_034 - Lost and Found Property_v6.pdf","consent":false},
{"name":"SOP_035 - Events Operations Process Supervisor_v5","path":"SOP_035 - Events Operations Process Supervisor_v5.docx","consent":false},
{"name":"SOP_040 - Notification and Escalation_v5.pdf","path":"SOP_040 - Notification and Escalation_v5.pdf"}]
},
{
  "name":"swps",
  "displayName":"Safe Work Procedures",
  "documents":[{"name":"SWP_001 - Armed Hold Up_v5","path":"SWP_001 - Armed Hold Up_v5.pdf","consent":false},
{"name":"SWP_002 - Barricade Patron Lift_v6","path":"SWP_002 - Barricade Patron Lift_v6.pdf","consent":false},
{"name":"SWP_003 - Cash Handling Cash in Transit_v6","path":"SWP_003 - Cash Handling Cash in Transit_v6.pdf","consent":false},
{"name":"SWP_004 - Cold Work Environment_v7","path":"SWP_004 - Cold Work Environment_v7.pdf","consent":false},
{"name":"SWP_005 - Sharps Handling_v8","path":"SWP_005 - Sharps Handling_v8.pdf","consent":false},
{"name":"SWP_006 - Electrical Hazards_v9","path":"SWP_006 - Electrical Hazards_v9.pdf","consent":false},
{"name":"SWP_007 - Fire and Evacuation_v10","path":"SWP_007 - Fire and Evacuation_v10.pdf","consent":false},
{"name":"SWP_008 - First Aid, Bodily Fluids and Sharps_v11","path":"SWP_008 - First Aid, Bodily Fluids and Sharps_v11.pdf","consent":false},
{"name":"SWP_009 - Hazardous Substances_v5","path":"SWP_009 - Hazardous Substances_v5.pdf","consent":false},
{"name":"SWP_010 - Hazardous Manual Tasks - Bollards, Barriers and Gates_v6","path":"SWP_010 - Hazardous Manual Tasks - Bollards, Barriers and Gates_v6.pdf","consent":false},
{"name":"SWP_011 - Manual Handling (General)_v7","path":"SWP_011 - Manual Handling (General)_v7.pdf","consent":false},
{"name":"SWP_012 - Patrol General_v8","path":"SWP_012 - Patrol General_v8.pdf","consent":false},
{"name":"SWP_013 - Responding to Incidents (General)_v5","path":"SWP_013 - Responding to Incidents (General)_v5.pdf","consent":false},
{"name":"SWP_014 - Shiftwork and Fatigue_v6","path":"SWP_014 - Shiftwork and Fatigue_v6.pdf","consent":false},
{"name":"SWP_015 - Stress and Burnout_v5","path":"SWP_015 - Stress and Burnout_v5.pdf","consent":false},
{"name":"SWP_016 - UV Radiation - Heat Stress_v6","path":"SWP_016 - UV Radiation - Heat Stress_v6.pdf","consent":false},
{"name":"SWP_017 - Vehicle Driving Fatigue_v6","path":"SWP_017 - Vehicle Driving Fatigue_v6.pdf","consent":false},
{"name":"SWP_018 - Violence and Aggression_v5","path":"SWP_018 - Violence and Aggression_v5.pdf","consent":false},
{"name":"SWP_019 - Working at Heights_v6","path":"SWP_019 - Working at Heights_v6.pdf","consent":false},
{"name":"SWP_020 - Working Around Roads_v5","path":"SWP_020 - Working Around Roads_v5.pdf","consent":false},
{"name":"SWP_021 - Workplace Noise_v5","path":"SWP_021 - Workplace Noise_v5.pdf","consent":false},
{"name":"SWP_023 - Water Retrieval (land)_v7","path":"SWP_023 - Water Retrieval (land)_v7.pdf","consent":false},
{"name":"SWP_027 - Handling Dead Animals_v3","path":"SWP_027 - Handling Dead Animals_v3.pdf","consent":false},
{"name":"SWP_028 - Venomous Snakes_v3","path":"SWP_028 - Venomous Snakes_v3.pdf","consent":false},
{"name":"SWP_030 - Extinguish Flare Using Sand Bucket_v3.pdf","path":"SWP_030 - Extinguish Flare Using Sand Bucket_v3.pdf"}]
},
{
  "name":"shfa-sops",
  "displayName":"SHFA Standard Operating Procedures",
  "documents":[{"name":"SOP_016_SO_SHFA - Operating SeaHawk_v3","path":"SOP_016_SO_SHFA - Operating SeaHawk_v3.pdf","consent":false},
{"name":"SOP_017_SO_SHFA - Seahawk Start Up & Shut Down_v3","path":"SOP_017_SO_SHFA - Seahawk Start Up & Shut Down_v3.pdf"}]
}
  ])
  
    const refreshPage = () => {
        window.location.reload(false);
      };
  
    const handleSubmit = async (event) => {
    
      setLoading(true);
      event.preventDefault();
      let parserFcn = new Promise((resolve, reject)=>{resolve('done')});

      documents.map((folder, index) => {
      let responseData = {
        body: {
         User:requestor,
         PolicyCategory:folder.name,
         CategoryDisplayName: folder.displayName,
         Policies:folder.documents,
         TimeOfAck: (new Date()).toLocaleString()
        }, 
        headers: {
        }, 
        response: false
    };

    console.log(JSON.stringify(responseData.body));
       parserFcn = parserFcn.then(()=> API.post('EmployeePortal', '/policy',responseData));
    })
    parserFcn.then((response)=>{
      console.log(response);
      setSuccess(true);
      setFormSuccess('Thank you');
      setLoading(false);
      setError(false);
    });

    parserFcn.catch(error => {
       console.log(error);
       setSuccess(false);
       setError(true);
       setFormSuccess("Something went wrong. Please try again.");
       setLoading(false);     });

     await parserFcn;
     /* }
      else
      {
        alert("Please acknowledge by ticking the checkbox!")
      }*/
   /*   const myInit = {
        body: {'requestor': requestor, 'po':po, 'username':user?.user?.username, 'request': shiftRequest, 'email':user?.user?.attributes?.email}, 
        headers: {
        }, 
        response: false
    };
    console.log(myInit);

     API.post('slhdclient', '/submitRequest',myInit).then(response => {
       console.log(response);
        setSuccess(true);
        setFormSuccess("Thank you. Your Service Request has been received. <br/>You will receive a confirmation email containing your booking request shortly.");
        setLoading(false);
        setError(false);
      })
      .catch(error => {
        console.log(error);
        setSuccess(false);
        setError(true);
        setFormSuccess("Something went wrong. Please try again.");
        setLoading(false);
      });*/
    };

   /* useEffect(()=>{
      setInitialising(true)
     
      var docList = documents.slice();

      documents.forEach(folder=>{
        folder?.documents?.forEach(document=>{
             this.getFile(`${folder.name}\\${folder.documents}`)
        })
             
      })
      
        return () => {
          isCancelled.current = true;
        };
    },[]);*/

   /*  const getFile= (key) =>{
      return new Promise((resolve, reject) => {
          Storage.get(key).then(url=>{
              resolve({url:url,name:key});
          }).catch(err=>{
              console.log("error", err);
              reject(err);
          });
      });
  }*/

    const openInNewTab = (key) => {
      console.log("key",key);
       Storage.get(key).then(url=>{
         console.log("url",url);
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
      }).catch(ex=>console.log(ex))
    
    }

    const onClickUrl = (key) => {
      return () => openInNewTab(key)
    }
 
    const handleDataChange = (data, folderIdx, docIdx) => 
    {
         var currentDoc = documents.slice();
         currentDoc[folderIdx].documents[docIdx].consent = data;
         setDocuments(currentDoc);
    };

/*    

    const getFiles = (folder, fileList) => {
      return new Promise((resolve, reject)=>{
        let parserFcn = new Promise((resolve, reject)=>{resolve('done')});
             fileList.forEach((res) => {
                parserFcn = parserFcn.then(()=>this.getFile(`${folder}\${res.path}`,imageList));
            });
            parserFcn.then(()=>resolve(imageList));
      })
    }
*/



    return (
    <ThemeProvider theme={theme}>
    <CssBaseline />
 {success ?
 <Container component="main" maxWidth="md" sx={{ m: 3 }}>
   <Grid container spacing={1}>
  <BlackTextTypography component="h1" variant="h5" color="primary" sx={{ m: 3 }} style={{ whiteSpace: "pre-line" }}>
         {formSuccess.split("<br/>").join("\n")}
   </BlackTextTypography>
         <Grid item xs={12}>
                </Grid>
      <Button
      type="button"
              fullWidth
              variant="contained"
              sx={{ mt: 20, mb: 2, pt: 10 }}
              onClick={refreshPage}
            >Click to Go Back</Button>
            </Grid>
 </Container>
:
   <Container component="main" maxWidth="md" sx={{ m: 3 }}>
      {
       error && <BlackTextTypography component="h1" variant="h5" color="secondary">
           {formSuccess}
       </BlackTextTypography>
      }
      <br/>
      <BlackTextTypography component="h1" variant="h5" color="primary">
      ACESGroup Employee Information  
      </BlackTextTypography>
      <br/>
      <BlackTextTypography component="h1" variant="body1" color="primary">
Please be aware of the below policies, procedures and safe work practices and employment information. It is important that staff read and acknowledge relevant document. To acknowledge each document, please open and read the information then check the relevant box and submit.
</BlackTextTypography>
       <Box  sx={{ mt: 3 }}>
             
                    {documents &&
                      documents.map((folder, index) => (
                        <Box sx={{ mt: 3, mr:1, position: 'relative' }}>
                        <BlackTextTypography sx={{ mt: 3 }} component="h1" variant="h5" color="primary">
                                 {folder.displayName}
                        </BlackTextTypography>
                        <ul className="list-group">
                        {folder?.documents?.map((image, idx)=>(
                          
                        <ListItem
                          divider
                          key={idx}>
                             <Checkbox
                  checked={image.consent}
                key="consent"
                onChange={event => {handleDataChange(!image.consent, index,idx)}}
               />
               &nbsp;
                          <a href="#" onClick={onClickUrl(`${folder.name}/${image.path}`)}>{image.name}</a>
                         
                         
                        </ListItem>
                       
                        ))}
                        </ul>
                        </Box>
                      ))}
                  
         <Box sx={{ mt: 3, mr:1, position: 'relative' }}>
        
         <Button
           type="button"
           fullWidth
           variant="contained"
           sx={{ mt: 3, mb: 2, }}
           align="center"
           onClick={handleSubmit}
           disabled={loading}
         >
           Submit
         </Button>
         {loading && (
       <CircularProgress
         size={24}
         sx={{
           position: 'absolute',
           top: '50%',
           left: '50%',
           mt: -6,
           ml: -6,
         }}
       />
     )}
         </Box>
       </Box>
       <Box sx={{ mt: 3, mr:1, position: 'relative' }}>
     <Copyright />
     </Box>
   </Container>
}
 </ThemeProvider>
  )}

  export default ReviewDocuments;

